<template>
  <div class="login_bimg" v-if="dialogVisible">
    <div class="content" :style="{ width: chooseUserWidthOut }">
      <div class="content_header">
        <div class="content-box-div">
          <div class="content-box-title">选择身份</div>
        </div>
      </div>
      <div class="content_right_login" id="chooseUser" :style="{ width: chooseUserWidth }">
        <!-- <template> -->
        <VueSlickCarousel v-bind="settings">
          <div
            v-for="item in weChatUserInfo"
            :key="item.LoginName"
            class="User"
            @click="WeChatUserInfoChoose(item.LoginName)"
            @mouseenter="changeImageSrc(item.LoginName)"
            @mouseleave="changeImageSrc()"
          >
            <el-card :body-style="{ height: '360px' }">
              <div class="imageLogo">
                <img class="imageLogoInfo" :src="item.LogoUrl" />
              </div>
              <div class="userType">
                {{ item.UserType == 0 ? "" : item.UserType == 1 ? item.OwnedGroupName : item.OwnedStationName }}
              </div>
              <div class="userTypeRemark">
                {{ item.UserType == 0 ? "" : item.UserType == 1 ? "(集团版)" : "(机构版)" }}
              </div>
              <div class="userRole">{{ item.RoleNames.split(",")[0] }}</div>
              <div class="userInfo">
                {{ item.LoginName.length >= 10 ? item.LoginName.substring(0, 3) + "***" + item.LoginName.substr(item.LoginName.length - 3, 3) : item.LoginName }}
              </div>
              <div class="imageGotoShow">
                <img v-if="item.LoginName != SelectUserName" :src="require('@static/img/goto.png')" />
                <img v-else :src="require('@static/img/goto_selected.png')" />
              </div>
            </el-card>
          </div>
        </VueSlickCarousel>
      </div>
      <!--添加弹出框-->
      <TipMsgDialog :userOptions="tipOptions" @tipMsgOK="tigMsgInfo()" @tipMsgClose="tipMsgCancel()" @tipMsgCancel="tipMsgCancel()" v-if="tipOptions.visible"></TipMsgDialog>
    </div>
    <div
      style="
        text-align: center;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 30px;
        color: white;
      "
    >
      冀ICP备15001061号-3
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import { InitAll } from "@/js/DropDownList.js";
//读取敏感词配置文件
import { sensitiveWordsArray } from "@/js/globalConfig.js";
export default {
  data() {
    return {
      activeName: "userlogin",
      userType: 0,
      OwnedStationCode: "",
      showDialog: false,
      tipOptions: {
        showType: 0,
        visible: false,
        showDesp: true,
        btnTitle: "确 定",
        msg: "是否删除此条数据？",
        desp: "删除后不可恢复。",
        showCancelBtn: true,
      },
      tipFlag: 0,
      dialogTitle: "",
      bg: {},
      rememberPassword: false,
      autologin: false,
      userName: "",
      password: "",
      validateCode: "",
      Inputactive: "",
      Inputactive1: "",
      Inputactive2: "",
      promptInfo: "",
      loading: null,
      btnClass: "login_btn login_btn_color",
      //图片验证码src
      validateCodeBase64: "",
      //客户端uuid，用于判断验证码
      clientUUID: "",
      weChatAPPID: "",
      weChatRedirectURL: "",
      weChatState: "",
      weChatScope: "",
      dialogVisible: false,
      weChatToken: "",
      weChatUserInfo: [],
      weChatUserInfoSelected: "",
      showValidateCode: false,
      showWeChat: false,
      settings: {
        dots: true,
        arrows: true,
        speed: 500,
        rows: 1,
        slidesToShow: 3,
        slidesToScroll: 3,
        touchThreshold: 5,
        focusOnSelect: false,
      },
      chooseUserWidth: "55%",
      chooseUserWidthOut: "55%",
      SelectUserName: "",
      divshow: [],
    };
  },
  mounted() {},
  beforeCreate: function() {},
  created() {
    this.loading = this.$loading({
      lock: true,
      text: "正在登录...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.InitWeChatInfo();
  },
  beforeDestroy: function() {
    document.onkeydown = function(e) {};
  },
  components: {
    VueSlickCarousel: VueSlickCarousel,
  },
  methods: {
    tigMsgInfo: function() {
      this.tipOptions.visible = false;
      if (this.tipOptions.showCancelBtn == true) {
        if (this.tipFlag == 1) {
          this.dialogTitle = "修改密码";
          this.promptInfo = "";
          this.showDialog = true;
          this.$refs.OpenDialog.getPasswordRule();
        }
      }
    },
    tipMsgCancel: function() {
      this.tipOptions.visible = false;
      if (this.tipFlag == 1) {
        this.getAuthToken();
      }
    },
    dialogClose(visible) {
      this.showDialog = visible;
    },
    rnd(n, m) {
      var random = Math.floor(Math.random() * (m - n + 1) + n);
      return random;
    },
    getUserInfo() {
      this.$axios
        .post("/Login/GetLoginUser", {})
        .then(async res => {
          if (res.data.Code == "10000") {
            this.$store.dispatch("user/saveuser", res.data.Data);
            this.userType = res.data.Data.UserType;
            this.OwnedStationCode = res.data.Data.OwnedStationCode;
            //加载下拉菜单项，存入store
            await InitAll(this.userType, null, this.OwnedStationCode);
            sensitiveWordsArray();
            //进入主界面
            this.$router.push({
              name: "平台主页",
            });
          } else {
            this.$store.dispatch("user/removetoken");
            this.$store.dispatch("user/removeuser");
            this.$message.error(res.data.msg);
            this.$router.push("/login");
          }
        })
        .catch(err => {
          if (this.loading) this.loading.close();
          console.log(err);
          if (err.response.status == undefined || err.response.status == null) {
            this.$message.error("服务端连接错误3！");
          } else if (err.response.status == 504) {
            this.$message.error("网络连接超时，请检查网络连接是否异常！");
          } else {
            this.$message.error("获取用户信息错误！");
            this.$store.dispatch("user/removetoken");
            this.$store.dispatch("user/removeuser");
          }
          this.$router.push("/login");
        });
    },
    InitWeChatInfo() {
      var check = false;
      if (window.location.href.indexOf("code") >= 0 && window.location.href.indexOf("state") >= 0) {
        //如果url中包含code,则保存到store中
        let code = window.location.href.split("?")[1];
        code = code.substring(5, code.indexOf("&"));
        let state = window.location.href.split("&")[1];
        state = state.substring(6);
        //获取token值
        if (code) {
          check = true;
          this.$axios
            .post("/WeChatLogin/GetWeChatTokenInfo", {
              Code: code,
              State: state,
            })
            .then(res => {
              if (res.data.Code == "10000") {
                console.log(res.data.Data.UserInfos);
                this.weChatUserInfo = res.data.Data.UserInfos;
                this.weChatUserToken = res.data.Data.Token;
                if (this.weChatUserInfo && this.weChatUserInfo.length > 1) {
                  if (this.loading) this.loading.close();
                  this.dialogVisible = true;
                  if (this.weChatUserInfo.length >= 3) {
                    this.settings.slidesToShow = 3;
                    this.settings.slidesToScroll = 3;
                    this.chooseUserWidth = "45%";
                    this.chooseUserWidthOut = "50%";
                  } else {
                    this.settings.slidesToShow = 2;
                    this.settings.slidesToScroll = 2;
                    this.chooseUserWidth = "30%";
                    this.chooseUserWidthOut = "35%";
                  }
                  this.weChatUserInfo.forEach(element => {
                    if (!element.LogoUrl) {
                      if (element.UserType == 1) {
                        element.LogoUrl = require("@static/img/logo_group.png");
                      } else if (element.UserType == 2) {
                        element.LogoUrl = require("@static/img/logo_station.png");
                      } else {
                        element.LogoUrl = require("@static/img/logo_station.png");
                      }
                    } else {
                      element.LogoUrl = this.$store.state.globalConfig.ImgFolderPath + element.LogoUrl;
                      console.log(element.LogoUrl);
                    }
                  });
                } else {
                  // this.loading = this.$loading({
                  //   lock: true,
                  //   text: "正在登录...",
                  //   spinner: "el-icon-loading",
                  //   background: "rgba(0, 0, 0, 0.7)",
                  // });
                  // this.weChatUserInfoSelected = this.weChatUserInfo[0].LoginName;
                  this.WeChatUserInfoChoose(this.weChatUserInfo[0].LoginName);
                }
              } else if (res.data.Code == "20001") {
                this.$message.error("微信扫码获取用户信息参数异常,请重试！");
                this.$store.dispatch("user/removetoken");
                if (this.loading) this.loading.close();
                this.$router.push("/login");
              } else {
                this.$message.error("用户未与微信账号进行绑定，或该账号已被禁用");
                this.$store.dispatch("user/removetoken");
                if (this.loading) this.loading.close();
                this.$router.push("/login");
              }
            })
            .catch(err => {
              if (this.loading) this.loading.close();
              if (err.response.status == undefined || err.response.status == null) {
                this.$message.error("服务端连接错误2！");
              } else if (err.response.status == 504) {
                this.$message.error("网络连接超时，请检查网络连接是否异常！");
              } else {
                this.$message.error("用户未与微信账号进行绑定，或该账号已被禁用");
                this.$store.dispatch("user/removetoken");
              }
              if (this.loading) this.loading.close();
              this.$router.push("/login");
            });
        }
      }
      if (!check) {
        if (this.loading) this.loading.close();
        this.$router.push("/login");
        // this.$my_confirm({
        //   showType: 0,
        //   msg: "无访问权限",
        //   showCancelBtn: false,
        //   imgSrc: require("@static/img/del.png"),
        //   msgClass: "tip-text-color-red",
        //   btnType: "reds",
        //   btnTitle: "确 定",
        // }).then((isOk) => {
        //   if (isOk) {
        //     // this.$message.error("获取用户信息错误！");
        //     // this.$store.dispatch("user/removetoken");
        //     // this.$store.dispatch("user/removeuser");
        //     this.$router.push("/login");
        //   }
        // });
      }
    },
    WeChatUserInfoChoose(userName) {
      this.weChatUserInfoSelected = userName;
      if (this.weChatUserInfoSelected) {
        if (!this.loading) {
          this.loading = this.$loading({
            lock: true,
            text: "正在登录...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
        }
        this.$axios
          .post("/OAuth/Token", {
            grant_type: "WeChat",
            Token: this.weChatUserToken,
            Username: this.weChatUserInfoSelected,
          })
          .then(res => {
            //获取用户信息
            this.$store.dispatch("user/savetoken", res.data.access_token);
            this.getUserInfo();
            if (this.loading) this.loading.close();
            return;
          })
          .catch(err => {
            if (this.loading) this.loading.close();
            if (err.response.status == undefined || err.response.status == null) {
              this.$message.error("服务端连接错误2！");
              console.log(err);
            } else if (err.response.status == 504) {
              this.$message.error("网络连接超时，请检查网络连接是否异常！");
            } else {
              this.$message.error("用户微信登录异常，请重试！");
              this.$store.dispatch("user/removetoken");
            }
          });
      }
    },
    changeImageSrc(userLoginName) {
      this.SelectUserName = userLoginName;
    },
  },
};
</script>

<style scoped>
.content-box-div span {
  width: 14px;
  height: 14px;
  display: block;
  border-radius: 100%;
  background: #ffbf05;
  margin-bottom: 15px;
}
.content-box-div {
  padding: 20px;
}
.content-box-title {
  font-size: 20px;
  font-weight: bold;
  color: rgb(255, 255, 255);
  line-height: 28px;
  margin-top: 10px;
  text-align: center;
}

.content {
  /* background-color: rgba(255, 255, 255, 0.2); */
  width: 930px;
  height: 483px;
  margin: auto;
  margin-top: 10%;
  /* border-radius: 16px; */
  /* box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2); */
  overflow: hidden;
  opacity: 1;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.23) 0%,
    rgba(149, 185, 255, 0.68) 1%,
    rgba(61, 106, 255, 0.45) 7%,
    rgba(255, 255, 255, 0.15) 49%,
    rgba(255, 255, 255, 0.19) 85%,
    rgba(110, 135, 222, 0.36) 92%,
    rgba(255, 255, 255, 0.21)
  );
  border: 1px solid rgba(255, 255, 255, 0.29);
  border-radius: 13px;
  box-shadow: 0px 16px 24px 0px rgba(0, 20, 86, 0.44);
}
.login_bimg {
  background-image: url(../assets/login_bgnew2.jpg);
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.content_header {
  height: 50px;
  width: 100%;
}
.content-box-img {
  float: right;
  margin-top: -25px;
}
.content_left_bimg {
  /* background-image: url(../assets/login_left_img.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;*/
  display: inline-block;
  height: 100%;
  width: 226px;
  padding-top: 60px;
  padding-left: 40px;
}
.content_left_bimg img {
  height: 200px;
}
.content_right_login {
  position: absolute;
  display: inline-block;
  margin-left: 60px;
  margin-right: 96px;
  padding-top: 35px;
  width: 830px;
  height: 638px;
}
.content_right_login #tit {
  display: block;
  font-size: 24px;
  padding-bottom: 20px;
}
.content_right_login input {
  padding-left: 0px;
  font-size: 16px;
  border: 0 none;
  border-bottom: 2px solid #b4bac2;
  width: 220px;
  height: 52px;
  background-color: transparent;
}
.login_btn {
  width: 230px;
  height: 34px;
  border-radius: 38px;
}
.login_btn_color {
  background: #c1d1de;
  border: 1px solid #b1c0cc;
  color: #fff;
}
/*.login_btn_color:hover,
.login_btn_color:focus {
  background: #4c85ff;
  border: 1px solid #4c85ff;
  color: #fff;
}*/
.login_btn_color_focus {
  background: #4c85ff;
  border: 1px solid #4c85ff;
  color: #fff;
}
.login_input {
  margin-top: 10px;
}
.login_input:-internal-autofill-selected {
  background-color: green !important;
}

.fontClass {
  font-size: 20px;
  font-weight: bold;
}

.wechatChoose {
  margin-top: 20vh;
}
.wechatClass {
  font-size: 18px;
}
.el-divider--vertical {
  display: inline-block;
  width: 1px;
  height: 220px;
  margin: 0 8px;
  vertical-align: middle;
  position: relative;
}
#chooseUser >>> .User {
  padding: -10px !important;
  width: 235px !important;
}

/* .slick-slide,
.slick-active div:nth-child(0) {
  padding: 0px 20px;
} */

#chooseUser >>> .imageLogo {
  padding-top: 20px !important;
  height: 50px;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  text-align: center;
}
#chooseUser >>> .imageLogoInfo {
  height: auto;
  width: auto;
  max-width: 75%;
  max-height: 100%;
}

#chooseUser >>> .imageGotoShow {
  padding-top: 20px;
  height: 50px;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  text-align: center;
}

#chooseUser >>> .userInfo {
  opacity: 1;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #a4a4a4;
}
#chooseUser >>> .userRole {
  padding-top: 80px;
  opacity: 1;
  font-size: 18px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  color: #000000;
}
.userType {
  padding-top: 20px;
  text-align: center;
  opacity: 1;
  font-size: 15px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #000000;
}
.userTypeRemark {
  opacity: 1;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #a4a4a4;
}

/* #chooseUser >>> .slick-prev:before {
  color: black;
}

#chooseUser >>> .slick-next:before {
  color: black;
} */

/* #chooseUser >>> .slick-active:before {
  color: black;
  content: require("@static/img/select1.png)");
} */

#chooseUser >>> .slick-dots li.slick-active button:before {
  padding-left: 5px;
  opacity: 1;
  content: url(../../static/img/select1.png);
  /* background-image: url(../img/select1.png); */
}
#chooseUser >>> .slick-dots li button:before {
  padding-left: 5px;
  opacity: 1;
  content: url(../../static/img/select2.png);
  /* background-image: url(../img/select1.png); */
}
#chooseUser >>> .slick-dots li {
  width: 30px;
}
#chooseUser >>> .slick-next {
  right: 0px;
}
#chooseUser >>> .slick-list {
  padding-left: 10px;
}
#chooseUser >>> .slick-initialized .slick-slide[data-v-e4caeaf8] div:first-child {
  padding: 0px 0px 0px 0px;
}
</style>
<style>
/* .slick-initialized .slick-slide[data-v-e4caeaf8] div:nth-child(1) {
  margin: 0px 0px 0px 0px;
}  */
</style>



// WEBPACK FOOTER //
// src/components/loginByWeChat.vue